export const experienceStyles = {
    companyCard: {
        p: 3, 
        cursor: 'pointer',
        transition: 'all 0.3s ease-in-out',
        '&:hover': { 
            transform: 'scale(1.02)',
            boxShadow: '0 10px 20px rgba(0,0,0,0.12)',
        },
        background: 'rgba(255, 255, 255, 0.05)',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '4px',
            background: (theme) => `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.primary.light})`
        }
    },
    companyName: {
        fontWeight: 600,
        mb: 1,
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 1
    },
    duration: {
        display: 'flex',
        alignItems: 'center',
        gap: 1
    },
    currentRole: {
        fontWeight: 500,
        fontSize: '1.1rem'
    },
    acquisitionLink: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        fontSize: '0.85em',
        color: '#64B5F6',
        backgroundColor: 'rgba(25, 118, 210, 0.04)',
        padding: '2px 8px',
        borderRadius: '4px',
        textDecoration: 'none',
        transition: 'all 0.2s ease-in-out',
        border: '1px solid',
        borderColor: 'rgba(25, 118, 210, 0.25)',
        ml: 1,
        '&:hover': {
            backgroundColor: '#64B5F6',
            color: '#000',
            borderColor: '#64B5F6',
            transform: 'translateY(-1px)',
            '& .MuiSvgIcon-root.external-icon': {
                transform: 'translate(1px, -1px)'
            }
        },
        '& .MuiSvgIcon-root': {
            fontSize: '0.9em'
        },
        '& .MuiSvgIcon-root.external-icon': {
            transition: 'transform 0.2s ease-in-out',
            fontSize: '0.8em',
            opacity: 0.8
        },
        '& .merge-icon': {
            transform: 'rotate(180deg)'
        }
    },
    technologyChip: {
        background: 'rgba(255, 255, 255, 0.1)',
        color: 'text.primary',
        '&:hover': {
            background: 'rgba(255, 255, 255, 0.15)'
        }
    },
    moreChip: {
        background: 'rgba(255, 255, 255, 0.05)',
        color: 'text.secondary'
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2
    },
    modalContent: {
        maxWidth: 1000,
        width: '100%',
        maxHeight: '90vh',
        overflow: 'auto',
        bgcolor: 'background.paper',
        borderRadius: 2,
        p: 4,
        position: 'relative',
        boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        '&::-webkit-scrollbar': {
            width: '8px',
        },
        '&::-webkit-scrollbar-track': {
            background: 'rgba(0,0,0,0.1)',
            borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb': {
            background: 'rgba(0,0,0,0.2)',
            borderRadius: '4px',
            '&:hover': {
                background: 'rgba(0,0,0,0.3)',
            },
        },
    },
    closeButton: {
        position: 'absolute',
        right: 16,
        top: 16,
        color: 'text.secondary',
        '&:hover': {
            color: 'text.primary',
            background: 'rgba(0,0,0,0.04)'
        }
    },
    modalTitle: {
        color: 'primary.main',
        fontWeight: 600,
        mb: 3
    }
}; 